/** 拉取 JSON；若拿到 SPA 的 index.html（常见于线上未部署 /data）会给出明确错误 */
export async function fetchJson<T>(url: string, label: string): Promise<T> {
  const res = await fetch(url, { cache: "no-store" });
  const text = await res.text();
  const trimmed = text.trimStart();

  if (!res.ok) {
    throw new Error(`${label} 请求失败（HTTP ${res.status}）`);
  }
  if (trimmed.startsWith("<!") || trimmed.startsWith("<html")) {
    throw new Error(
      `${label} 返回了网页而不是数据文件。请在本机执行 npm run content:assemble 后刷新，或检查服务器是否已部署 /data/*.json`
    );
  }
  try {
    return JSON.parse(text) as T;
  } catch {
    throw new Error(`${label} 不是有效的 JSON`);
  }
}
